(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.colorbox_quiz_fix = {
    initializeColorbox: function (context) {
      once("do-colorbox", ".modal-quiz-link", context)
        .forEach(function (element) {
          if (typeof $.colorbox !== "function") {
            return;
          }

          const $link = $(element);
          const targetSelector = $link.attr("data-colorbox-inline");

          if (!targetSelector || !$(targetSelector).length) {
            return;
          }

          $(targetSelector).css("visibility", "visible");

          $link.colorbox({
            inline: true,
            href: targetSelector,

            onOpen: function () {
              $(targetSelector).show().css("opacity", 0);
            },

            onComplete: function () {
              $(targetSelector).animate({
                opacity: 1,
              }, 1100);
            },

            onClosed: function () {
              $(targetSelector).hide();
            },
          });
        });
    },

    handleQuizResult: function (context) {
      once("quiz-result-response", ".quiz-result-response", context)
        .forEach(function (element) {
          const resultUrl = element.dataset.resultUrl;

          if (!resultUrl) {
            return;
          }

          window.open(resultUrl, "_blank", "noopener");

          if (typeof $.colorbox === "function") {
            $.colorbox.close();
          }
        });
    },

    attach: function (context) {
      const behavior = Drupal.behaviors.colorbox_quiz_fix;

      // Handles markup inserted through Drupal AJAX.
      behavior.handleQuizResult(context);

      // Register document-wide handlers only once.
      once("colorbox-quiz-document-ready", "html", context)
        .forEach(function () {
          setTimeout(function () {
            behavior.initializeColorbox(document);
          }, 500);

          $(document).ajaxComplete(function () {
            setTimeout(function () {
              behavior.initializeColorbox(document);
              behavior.handleQuizResult(document);
            }, 300);
          });
        });
    },

    detach: function (context, settings, trigger) {
      if (trigger === "unload") {
        once.remove("do-colorbox", ".modal-quiz-link", context);
        once.remove(
          "quiz-result-response",
          ".quiz-result-response",
          context,
        );
      }
    },
  };
})(jQuery, Drupal, once);
